// extracted by mini-css-extract-plugin
module.exports = {"image":"GalleryBlock_image__tdMlQ","image-img":"GalleryBlock_image-img__oEzLM","image-text":"GalleryBlock_image-text__h7Ov0"};